<div class="firstDiv" style="margin-top: 10%">
    <!-- Show message dynamically with correct color -->
    <div class="mainDiv">
        <h1 class="h2_font_size" [ngClass]="statusClass">{{ statusMessage }}</h1>
    </div>

    <!-- Show Try Again button for Failed or Unknown cases -->
    <div *ngIf="status" class="mainDiv" style="text-align: center">
        <button class="btn btn-primary" (click)="onTryAgain()" id="downloadBtnStyle">
            <span *ngIf="status !== 'Success'">Try Again</span>
            <span *ngIf="status == 'Success'">More Payment</span>
        </button>
    </div>

    <div class="payment-card" *ngIf="!status">

        <div class="spinner"></div>

        <h2>Verifying Your Transaction</h2>
        <p>Please wait while we confirm your order.</p>

        <div class="progress-container">
            <div class="progress-bar" [style.width.%]="progressPercent">
            </div>
        </div>

        <p class="time-text">
            This may take up to
            <strong>{{ remainingSeconds }}</strong>
            seconds
        </p>

        <p class="sub-text">
            Do not refresh or close this page.
        </p>
    </div>
</div>